import { Component, OnInit, computed, signal } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AuthService } from "src/app/helpers/services/auth.service";
import { LanguageService } from "src/app/helpers/services/language.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "loyaltic-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  navElement: HTMLElement | null = null;

  isDrawerOpen = false;
  isLogedIn = false;
  currentPage = "";
  isCollapsed = signal(false);
  //isLoggedIn = false;
  userId;
  currentLang = signal<string | null>("");
  isHomePage = signal(false);
  languages = ["se", "no", "dk"]; // Available languages
  languageandBrands = [
    { lang: "se", brand: "" },
    { lang: "no", brand: "elx" },
    { lang: "no", brand: "aeg" },
    { lang: "dk", brand: "elx" },
    { lang: "dk", brand: "aeg" },
  ];
  //languages = ['se', 'fi', 'no', 'dk', 'is']; // Available languages
  selectedLanguage = signal("se"); // Default language
  storedLanguage = signal("se");
  getTranslateDefaultLang = signal("");
  allowedCulturesForBranding = ["da-DK", "nb-NO"];
  brand = signal<string | null>(null);

  isAegBrandingCulture = computed(() =>
    this.allowedCulturesForBranding.includes(this.getTranslateDefaultLang()),
  );

  constructor(
    private router: Router,
    public authService: AuthService,
    private languageService: LanguageService,
    private translate: TranslateService,
  ) {
    //this.isLoggedIn = this.authService.IsLoggedIn();
    this.userId = this.authService.getUserId();
    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        //console.log(e);
        this.currentPage = e.urlAfterRedirects;
        if (this.currentPage === "/") {
          this.isHomePage.set(this.currentPage === `/`);
        } else {
          this.isHomePage.set(this.currentPage === `/${this.currentLang()}`);
        }
      }
    });

    // Subscribe to language changes
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang.set(lang);
      localStorage.setItem("selectedLanguage", lang ? lang : "");
      //console.log(this.currentLang());
    });
  }

  ngOnInit() {
    //this.onLanguageChange('se');
    this.getTranslateDefaultLang.set(this.translate.defaultLang);
    //console.log("Header " + this.translate.defaultLang);
    this.navElement = null;
    this.isDrawerOpen = false;
    if (this.authService.IsLoggedIn()) {
      this.isLogedIn = true;
    }
    const countryCode = localStorage
      .getItem("currLanguage")!
      .split("-")[1]
      .toLowerCase();
    this.storedLanguage.set(countryCode);
    this.brand.set(localStorage.getItem("brand"));
  }

  // onLanguageChange(lang: string) {
  //   this.selectedLanguage = lang;
  //   const hostname = window.location.hostname;
  //   console.log(hostname);
  //   console.log(this.selectedLanguage);

  //   if (hostname.includes('sweaegelx25')) {
  //     if (this.selectedLanguage === 'se') {
  //       window.location.href = `https://sweaegelx25.azurewebsites.net`;
  //     } else if (this.selectedLanguage === 'dk') {
  //       window.location.href = `https://sweaegelx25-dk.azurewebsites.net`;
  //     } else if (this.selectedLanguage === 'no') {
  //       window.location.href = `https://sweaegelx25-no.azurewebsites.net`;
  //     }
  //   }
  //   else {
  //     this.router.navigate([`/${lang}`]).then(() => {
  //         window.location.href = `/${lang}`;
  //     });
  //   }
  // }

  onLanguageChange(lang: string, brand: string) {
    const hostname = window.location.hostname;
    const route =
      lang === "se"
        ? `/${brand.toLocaleLowerCase()}${lang}`
        : `/${brand.toLocaleLowerCase()}-${lang}`;
    let targetDomain = "";

    if (lang === "dk") {
      // If current site is Azure, go to Azure site
      if (brand === "elx") {
        targetDomain = hostname.includes("azurewebsites.net")
          ? environment.dkDomains[0]
          : environment.dkDomains[1];
      } else {
        targetDomain = hostname.includes("azurewebsites.net")
          ? environment.dkAEGDomains[0]
          : environment.dkAEGDomains[1];
      }
    } else if (lang === "no") {
      if (brand === "elx") {
        targetDomain = hostname.includes("azurewebsites.net")
          ? environment.noDomains[0]
          : environment.noDomains[1];
      } else {
        targetDomain = hostname.includes("azurewebsites.net")
          ? environment.noAEGDomains[0]
          : environment.noAEGDomains[1];
      }
    } else if (lang === "se") {
      targetDomain = hostname.includes("azurewebsites.net")
        ? environment.seDomains[0]
        : environment.seDomains[1];
    }

    // console.log(targetDomain);
    // console.log(hostname);
    localStorage.setItem("brand", brand);

    if (hostname === "localhost") {
      // Case 3: running locally → route change only
      // this.router.navigate([`/${brand.toLocaleLowerCase()}-${lang}`]).then(() => {
      //   window.location.href = `/${brand.toLocaleLowerCase()}-${lang}`;
      // });

      // remove trailing "-" from se in the url
      this.router.navigate([route]).then(() => {
        window.location.href = route;
      });
    } else if (targetDomain && targetDomain !== hostname) {
      // Case 1: redirect to other domain
      window.location.href = `https://${targetDomain}`;
    } else {
      // Case 2: already on the correct domain → do nothing
      //console.log('Already on target domain, no redirect');
    }
  }

  getLanguageName(lang: string, brand: string): string {
    switch (lang) {
      case "se":
        return "Swedish (SE)";
      //case 'fi': return 'Finnish (FI)';
      case "no":
        return "Norwegian (NO) - " + brand;
      case "dk":
        return "Danish (DK) - " + brand;
      //case 'is': return 'Iceland (IS)';
      default:
        return "";
    }
  }

  onLogoutClick() {
    // this.isLoggedIn = false;
    // this.authService.resetTokens();
  }

  redirectToHome() {
    const defaultLang = this.currentLang();
    // Check if currentLang is null
    if (defaultLang === "") {
      this.router.navigate(["/"]);
    } else {
      this.router.navigate([`/${defaultLang}`]);
    }
    //this.router.navigate([`/${this.currentLang}`]);
  }
}
